var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 51,
    viewBox: "0 0 55 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_154_423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8667 16.538C7.66656 16.538 1 24.0438 1 32.3731C1 35.0334 1.77592 37.7728 3.13773 40.2748C3.39109 40.6865 3.42276 41.209 3.24858 41.6999L2.18763 45.247C1.9501 46.1021 2.67852 46.7355 3.4861 46.4821L6.68479 45.532C7.55571 45.247 8.23662 45.6112 9.04579 46.1021C11.3577 47.4639 14.2381 48.1606 16.8351 48.1606C24.6892 48.1606 32.6701 42.0958 32.6701 32.3256C32.6701 23.9013 25.861 16.538 16.8667 16.538Z",
    fill: "url(#paint0_linear_154_423)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_154_423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0876 23.3656C14.0876 29.0149 18.6661 33.5924 24.3144 33.5924C29.9627 33.5924 34.5412 29.0149 34.5412 23.3656C34.5412 17.7184 29.9627 13.1388 24.3144 13.1388C18.6661 13.1388 14.0876 17.7184 14.0876 23.3656Z",
    fill: "#E9747E"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_154_423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.54 7C39.2798 7 47.7866 16.5777 47.7866 27.2062C47.7866 30.6008 46.7965 34.0965 45.0588 37.2891C44.7355 37.8144 44.6951 38.4812 44.9173 39.1076L46.2712 43.6338C46.5743 44.7249 45.6448 45.5332 44.6143 45.2099L40.5326 43.9975C39.4213 43.6338 38.5524 44.0985 37.5199 44.7249C34.5698 46.4627 30.8943 47.3517 27.5804 47.3517C17.5582 47.3517 7.37428 39.6128 7.37428 27.1456C7.37428 16.3959 16.0629 7 27.54 7Z",
    fill: "white",
    fillOpacity: 0.35
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bd_154_423)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_154_423",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6199 29.8126C29.0545 29.7924 30.2063 28.6406 30.2063 27.206C30.2063 25.7915 29.0343 24.6196 27.6199 24.6398C26.1853 24.6398 25.0335 25.7915 25.0335 27.2262C25.0335 28.6406 26.1853 29.8126 27.6199 29.8126ZM36.9357 29.8126C38.3501 29.8126 39.5221 28.6406 39.5221 27.2262C39.5221 25.7915 38.3703 24.6398 36.9357 24.6398C35.5011 24.6398 34.3493 25.7915 34.3493 27.2262C34.3493 28.6406 35.5011 29.7924 36.9357 29.8126ZM20.8916 27.2262C20.8916 28.6406 19.7398 29.8125 18.3052 29.8125C16.8706 29.8125 15.7188 28.6406 15.7188 27.2262C15.7188 25.7915 16.8706 24.6398 18.3052 24.6398C19.7398 24.6398 20.8916 25.7915 20.8916 27.2262Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6199 29.8126C29.0545 29.7924 30.2063 28.6406 30.2063 27.206C30.2063 25.7915 29.0343 24.6196 27.6199 24.6398C26.1853 24.6398 25.0335 25.7915 25.0335 27.2262C25.0335 28.6406 26.1853 29.8126 27.6199 29.8126ZM36.9357 29.8126C38.3501 29.8126 39.5221 28.6406 39.5221 27.2262C39.5221 25.7915 38.3703 24.6398 36.9357 24.6398C35.5011 24.6398 34.3493 25.7915 34.3493 27.2262C34.3493 28.6406 35.5011 29.7924 36.9357 29.8126ZM20.8916 27.2262C20.8916 28.6406 19.7398 29.8125 18.3052 29.8125C16.8706 29.8125 15.7188 28.6406 15.7188 27.2262C15.7188 25.7915 16.8706 24.6398 18.3052 24.6398C19.7398 24.6398 20.8916 25.7915 20.8916 27.2262Z",
    fill: "url(#paint1_linear_154_423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6199 29.8126L27.6255 30.2126H27.6199V29.8126ZM27.6199 24.6398L27.6256 25.0398H27.6199V24.6398ZM36.9357 29.8126V30.2126L36.9301 30.2125L36.9357 29.8126ZM30.6063 27.206C30.6063 28.8626 29.2756 30.1893 27.6255 30.2125L27.6143 29.4126C28.8335 29.3954 29.8063 28.4186 29.8063 27.206H30.6063ZM27.6142 24.2398C29.2551 24.2164 30.6063 25.5718 30.6063 27.206H29.8063C29.8063 26.0113 28.8136 25.0228 27.6256 25.0397L27.6142 24.2398ZM24.6335 27.2262C24.6335 25.5706 25.9644 24.2398 27.6199 24.2398V25.0398C26.4062 25.0398 25.4335 26.0125 25.4335 27.2262H24.6335ZM27.6199 30.2126C25.9623 30.2126 24.6335 28.8595 24.6335 27.2262H25.4335C25.4335 28.4217 26.4082 29.4126 27.6199 29.4126V30.2126ZM39.9221 27.2262C39.9221 28.8615 38.5711 30.2126 36.9357 30.2126V29.4126C38.1292 29.4126 39.1221 28.4197 39.1221 27.2262H39.9221ZM36.9357 24.2398C38.5913 24.2398 39.9221 25.5706 39.9221 27.2262H39.1221C39.1221 26.0125 38.1494 25.0398 36.9357 25.0398V24.2398ZM33.9493 27.2262C33.9493 25.5706 35.2802 24.2398 36.9357 24.2398V25.0398C35.722 25.0398 34.7493 26.0125 34.7493 27.2262H33.9493ZM36.9301 30.2125C35.282 30.1893 33.9493 28.8646 33.9493 27.2262H34.7493C34.7493 28.4166 35.7201 29.3954 36.9413 29.4126L36.9301 30.2125ZM18.3052 29.4125C19.5169 29.4125 20.4916 28.4217 20.4916 27.2262H21.2916C21.2916 28.8595 19.9628 30.2125 18.3052 30.2125V29.4125ZM16.1188 27.2262C16.1188 28.4217 17.0935 29.4125 18.3052 29.4125V30.2125C16.6476 30.2125 15.3188 28.8595 15.3188 27.2262H16.1188ZM18.3052 25.0398C17.0915 25.0398 16.1188 26.0125 16.1188 27.2262H15.3188C15.3188 25.5706 16.6497 24.2398 18.3052 24.2398V25.0398ZM20.4916 27.2262C20.4916 26.0125 19.5189 25.0398 18.3052 25.0398V24.2398C19.9608 24.2398 21.2916 25.5706 21.2916 27.2262H20.4916Z",
    fill: "url(#paint2_linear_154_423)",
    mask: "url(#path-4-inside-1_154_423)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_154_423",
    x: -12,
    y: 0.138794,
    width: 59.5412,
    height: 61.0219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_154_423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_154_423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_154_423",
    x: 1.08759,
    y: 0.138794,
    width: 46.4536,
    height: 46.4536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_154_423"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_154_423",
    x: -7.62573,
    y: -8,
    width: 70.4124,
    height: 70.3517,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_154_423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_154_423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bd_154_423",
    x: 0.718811,
    y: 9.63953,
    width: 53.8033,
    height: 35.173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_154_423"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.966667 0 0 0 0 0.265833 0 0 0 0 0.323667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_154_423",
    result: "effect2_dropShadow_154_423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_154_423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_423",
    x1: 19.1666,
    y1: 34.4669,
    x2: -8.64561,
    y2: 48.0101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F74453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E02232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_423",
    x1: 17.4064,
    y1: 25.5737,
    x2: 43.365,
    y2: 29.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_423",
    x1: 42.2874,
    y1: 25.7891,
    x2: 39.7523,
    y2: 34.7555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.1170d280546c0ea92c591aa17e906ca7.svg";
export { ForwardRef as ReactComponent };